export type FundGateReason =
  | 'add'
  | 'deposit'
  | 'setDefault'
  | 'edit'
  | 'delete'
  | 'withdraw'
  | 'cancelWithdraw'
  | 'changeLoginPwd'
  | 'changePhone'
  | 'changeEmail'
  | 'generic'

export type FundGateCred = {
  fundPassword?: string
  verificationId?: string
}

type FundGateOk = (cred?: FundGateCred) => void | Promise<void>

export const useFundGate = () => {
  const open = useState('fund-verify-open', () => false)
  const reason = useState<FundGateReason>('fund-verify-reason', () => 'generic')
  const pendingOk = useState<FundGateOk | null>('fund-verify-ok', () => null)

  const { fundSet } = useSecurity()

  const requestFundGate = (r: FundGateReason, onOk: FundGateOk) => {
    if (!fundSet.value) {
      void Promise.resolve(onOk()).catch(() => {
        /* 业务错误已由 api 拦截器 toast */
      })
      return
    }
    reason.value = r
    pendingOk.value = onOk
    open.value = true
  }

  const closeFundGate = () => {
    open.value = false
    pendingOk.value = null
  }

  const resolveFundGate = async (cred?: FundGateCred) => {
    const cb = pendingOk.value
    if (!cb) {
      closeFundGate()
      return
    }
    try {
      await cb(cred)
      closeFundGate()
    } catch {
      /* 业务错误已由 api 拦截器 toast；弹层保持以便重试 */
    }
  }

  return {
    open,
    reason,
    requestFundGate,
    closeFundGate,
    resolveFundGate,
  }
}
